<template>
  <div id="app">
    <headernav></headernav>
    <gallery></gallery>
    <footprint></footprint>
  </div>
</template>

<script>
import headernav from './components/headernav.vue'
import gallery from './components/gallery.vue'
import footprint from './components/footprint.vue'

export default {
  name: 'App',
  components: {
    headernav,
    gallery,
    footprint,
  }
}
</script>

<style lang='less'>
#app {
  font-family            : 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing : antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-image       : url('http://overwatch.nos.netease.com/2/OW_OasisMap_009.jpg');
  background-position    : center;
  background-repeat      : no-repeat;
  background-size        : cover;
  background-attachment  : fixed;
  margin                 : 0;
  padding                : 0;
  min-height             : 100%;
  text-align             : center;
  color                  : #2e2e2e;
  position               : relative;
}
.container{
  width   : 960px;
  margin  : auto;
  overflow: hidden;
  display : block;
}
</style>



// WEBPACK FOOTER //
// src/App.vue